<template>
  <span class="svg-ico-all-my-contents">
    <svg
      v-if="isTwoTone"
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7276 19.4021H6.19203C5.58792 19.4021 5.08978 18.9153 5.08978 18.3122C5.08978 17.709 5.58792 17.2222 6.19203 17.2222H14.1939C14.4165 16.9153 14.6921 16.6296 15.0418 16.3968C15.1796 16.3016 15.3386 16.2275 15.4976 16.1429C14.957 15.5714 14.6179 14.7989 14.6179 13.9524C14.6179 12.1852 16.0699 10.7355 17.8505 10.7355C18.497 10.7355 19.0905 10.9259 19.5992 11.254V5.89947C19.5992 4.30159 18.2956 3 16.6846 3H6.4146C4.80362 3 3.5 4.29101 3.5 5.89947V18.1005C3.5 18.1005 3.5106 18.2064 3.5106 18.2593C3.4788 19.7619 4.67644 21 6.18144 21H14.7663C14.2257 20.5661 13.8548 20.0265 13.717 19.4233L13.7276 19.4021ZM7.1565 5.21164C7.1565 4.85185 7.45326 4.55556 7.82421 4.55556C8.19516 4.55556 8.49192 4.85185 8.49192 5.21164V14.7037C8.49192 15.0635 8.19516 15.3598 7.82421 15.3598C7.45326 15.3598 7.1565 15.0635 7.1565 14.7037V5.21164Z"
        :fill="color"
      />
      <path
        d="M15.932 17.508C16.9919 16.7461 18.7088 16.7461 19.7581 17.508C20.235 17.8466 20.4894 18.3122 20.5 18.8202C20.5 19.3281 20.235 19.7937 19.7581 20.1429C19.2282 20.5239 18.5393 20.7143 17.8398 20.7143C17.1403 20.7143 16.4513 20.5239 15.9214 20.1429C15.4445 19.8043 15.1795 19.3387 15.1795 18.8307C15.1795 18.3228 15.4445 17.8572 15.9214 17.508H15.932Z"
        :fill="color"
      />
      <path
        d="M7.81336 15.3809C7.45301 15.3809 7.15625 15.0846 7.15625 14.7248V5.16927C7.15625 4.80948 7.45301 4.51318 7.81336 4.51318C8.17371 4.51318 8.47047 4.80948 8.47047 5.16927V14.7142C8.47047 15.074 8.17371 15.3703 7.81336 15.3703V15.3809Z"
        :fill="color2"
      />
      <path
        d="M15.9424 13.9523C15.9424 12.9047 16.8009 12.0476 17.8502 12.0476C18.8994 12.0476 19.7579 12.9047 19.7579 13.9523C19.7579 14.9788 18.9418 15.8148 17.9137 15.8571H17.882C17.882 15.8571 17.829 15.8571 17.7972 15.8571C16.7479 15.8254 15.9424 14.9894 15.9424 13.9523Z"
        :fill="color2"
      />

    </svg>
    <svg
      v-else-if="isSolid"
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7276 19.4021H6.19203C5.58792 19.4021 5.08978 18.9153 5.08978 18.3122C5.08978 17.709 5.58792 17.2222 6.19203 17.2222H14.1939C14.4165 16.9153 14.6921 16.6296 15.0418 16.3968C15.1796 16.3016 15.3386 16.2275 15.4976 16.1429C14.957 15.5714 14.6179 14.7989 14.6179 13.9524C14.6179 12.1852 16.0699 10.7355 17.8505 10.7355C18.497 10.7355 19.0905 10.9259 19.5992 11.254V5.89947C19.5992 4.30159 18.2956 3 16.6846 3H6.4146C4.80362 3 3.5 4.29101 3.5 5.89947V18.1005C3.5 18.1005 3.5106 18.2064 3.5106 18.2593C3.4788 19.7619 4.67644 21 6.18144 21H14.7663C14.2257 20.5661 13.8548 20.0265 13.717 19.4233L13.7276 19.4021ZM7.1565 5.21164C7.1565 4.85185 7.45326 4.55556 7.82421 4.55556C8.19516 4.55556 8.49192 4.85185 8.49192 5.21164V14.7037C8.49192 15.0635 8.19516 15.3598 7.82421 15.3598C7.45326 15.3598 7.1565 15.0635 7.1565 14.7037V5.21164Z"
        :fill="color"
      />
      <path
        d="M15.9427 13.9524C15.9427 12.9048 16.8012 12.0477 17.8504 12.0477C18.8997 12.0477 19.7582 12.9048 19.7582 13.9524C19.7582 14.9789 18.9421 15.8149 17.914 15.8572H17.8822C17.8822 15.8572 17.8292 15.8572 17.7975 15.8572C16.7482 15.8254 15.9427 14.9895 15.9427 13.9524Z"
        :fill="color"
      />
      <path
        d="M15.932 17.508C16.9919 16.7461 18.7088 16.7461 19.7581 17.508C20.235 17.8466 20.4894 18.3122 20.5 18.8201C20.5 19.3281 20.235 19.7937 19.7581 20.1429C19.2282 20.5238 18.5393 20.7143 17.8398 20.7143C17.1403 20.7143 16.4513 20.5238 15.9214 20.1429C15.4445 19.8043 15.1795 19.3386 15.1795 18.8307C15.1795 18.3228 15.4445 17.8572 15.9214 17.508H15.932Z"
        :fill="color"
      />
    </svg>
    <svg
      v-else
      class="icon-color-1"
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0239 20.4757H6.25162C4.74073 20.4757 3.5 19.2113 3.5 17.659V5.81667C3.5 4.26442 4.73073 3 6.25162 3H15.9273C17.4382 3 18.679 4.26442 18.679 5.81667V9.51742C18.679 9.93889 18.3388 10.2884 17.9285 10.2884C17.5183 10.2884 17.1781 9.93889 17.1781 9.51742V5.81667C17.1781 5.11765 16.6177 4.54198 15.9273 4.54198H6.25162C5.56122 4.54198 5.00089 5.11765 5.00089 5.81667V17.659C5.00089 18.3581 5.56122 18.9337 6.25162 18.9337H10.0239C10.4341 18.9337 10.7743 19.2833 10.7743 19.7047C10.7743 20.1262 10.4341 20.4757 10.0239 20.4757Z"
        :fill="color"
      />
      <path
        d="M7.5724 16.7441C7.16216 16.7441 6.82196 16.3946 6.82196 15.9731V3.77099C6.82196 3.34951 7.16216 3 7.5724 3C7.98265 3 8.32285 3.34951 8.32285 3.77099V15.9731C8.32285 16.3946 7.98265 16.7441 7.5724 16.7441Z"
        :fill="color"
      />
      <path
        d="M11.7849 20.4757H6.0415C4.64067 20.4757 3.5 19.3141 3.5 17.8749C3.5 16.4357 4.64067 15.2741 6.0415 15.2741H11.7849C12.1951 15.2741 12.5353 15.6236 12.5353 16.0451C12.5353 16.4666 12.1951 16.8161 11.7849 16.8161H6.0415C5.47116 16.8161 5.00089 17.289 5.00089 17.8749C5.00089 18.4609 5.46116 18.9337 6.0415 18.9337H11.7849C12.1951 18.9337 12.5353 19.2833 12.5353 19.7047C12.5353 20.1262 12.1951 20.4757 11.7849 20.4757Z"
        :fill="color"
      />
      <path
        d="M17.098 16.2713C17.098 16.2713 17.0279 16.2713 16.9879 16.2713H16.9579C15.5671 16.2199 14.4764 15.0685 14.4764 13.6499C14.4764 12.2313 15.6171 11.0286 17.0279 11.0286C18.4388 11.0286 19.5795 12.2005 19.5795 13.6499C19.5795 15.0685 18.4888 16.2199 17.118 16.2713H17.088H17.098ZM16.9479 16.261C16.9479 16.261 16.9879 16.261 17.0079 16.261C16.9879 16.261 16.9679 16.261 16.9479 16.261ZM17.0279 14.7293C17.0279 14.7293 17.058 14.7293 17.078 14.7293C17.6483 14.7087 18.0886 14.2359 18.0886 13.6499C18.0886 13.0537 17.6183 12.5705 17.038 12.5705C16.4576 12.5705 15.9873 13.0537 15.9873 13.6499C15.9873 14.2461 16.4276 14.6985 17.0079 14.7293H17.0279Z"
        :fill="color"
      />
      <path
        d="M17.038 20.9897C16.1474 20.9897 15.2969 20.743 14.6565 20.301C13.9661 19.8281 13.5659 19.1291 13.5659 18.3889C13.5659 17.6488 13.9661 16.9395 14.6565 16.4666C15.9973 15.562 18.0786 15.5517 19.4094 16.4666C20.1098 16.9395 20.5 17.6179 20.5 18.3786C20.5 19.1393 20.1098 19.8178 19.4094 20.3113C18.759 20.7533 17.9185 21 17.0279 21L17.038 20.9897ZM15.497 17.7413C15.337 17.8544 15.0668 18.0805 15.0668 18.3786C15.0668 18.6768 15.3369 18.9029 15.487 19.016C16.2775 19.5608 17.7884 19.5608 18.5789 19.016C18.769 18.8824 19.0091 18.6562 19.0091 18.3684C19.0091 18.0805 18.779 17.8646 18.5889 17.731C17.7684 17.1656 16.3275 17.1656 15.497 17.731V17.7413Z"
        :fill="color"
      />

    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
